/* eslint-disable no-shadow */
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-string-refs */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/extensions */
import React, { useState, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { MapInteractionCSS } from 'react-map-interaction';
import { useTranslation } from 'react-i18next';
import themeStyles from '../../Constants/theme';
import toggleProjectSound from '../../assets/sounds/BUTTONS.wav';
import map from '../../assets/images/map.png';
import background from '../../assets/images/background.png';

import {
    X,
    Polygon4,
    Polygon5,
    Ellipse47,
    Ellipse50,
    Ellipse48,
    Polygon6,
    Rectangle75,
    TargetIcon,
} from '../../Constants/assets';
import { ReactComponent as BackArrow } from '../../assets/images/BackArrow.svg';
import { Board, Board as BoardData } from '../../data/Board';
import { Tile } from '../../components/index';


const Container = styled.div`
    position: relative;
    top: 54px;
    margin: 20 auto;
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;

`;
const LargeMapContainer = styled.div`
    width: 801px;
    height: 100%;    
    background: ${componentProps => componentProps.theme.colors.white};
    border: 1.4px solid ${props => props.theme.colors.darkGreen};
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    text-align: center;
    z-index: 100;
    position: absolute;
    display: grid;
    align-items: end;
`;
const LargeMapBackground = styled.div`
    background-image: url(${background});
    background-size: 170% 100%;
    background-repeat: no-repeat;    
    // width: 100%;
    width: 800px;
    height: 100%;
    position: relative;
`;
const TileContainer = styled.img`
    // background-image: url(${map});
    background-size: 100% 100%;
    background-repeat: no-repeat;  
    display:block;
    width: 100%;
    position: relative;
    scroll-behavior: smooth;
`;
const InfoContainer = styled.div`
    background: #FFFFFF;
    opacity: 0.9;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    width: 218px;
    height: 336px;
    margin: 0px 0px 10px 10px;
    position: absolute;
`;
const LineWrapper = styled.div`
    width: 75%;
    height: max-content;
    display: flex;
    margin-top: 12px;
    margin-left: 20px;
    justify-content: space-between;
    align-items: baseline;
`;

const ImageContainer = styled.div``;
const TextContainer = styled.div`
    font-weight: 400;
    font-size: 17px;
    width: 106px;
    height: 43px;
    text-align: initial;
    width: 80%;
`;
const RightLine = styled.div`
    width: 8vw;
    height: 7px;
    background: linear-gradient(
        ${props => (props.reverse ? 'to right' : 'to left')},
        ${props => props.previousCardColor},
        ${props => props.currentCardColor}
    );
    position: absolute;
    z-index: -1;
`;

const UpLine = styled.div`
    height: 12vh;
    width: 7px;
    background: linear-gradient(
        to top,
        ${props => props.previousCardColor},
        ${props => props.currentCardColor}
    );
    position: absolute;
    z-index: -1;
`;
const IconContainer = styled.div`
    width: 56px;
    height: 56px;
    opacity: 0.9;
    margin: 10px 0px 0px 10px;
    z-index: 6;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    background: ${props => props.theme.colors.white};

    :hover {
        cursor: pointer;
    }
    position: absolute;
`;
const HelpContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 100%;
`;
export default function ExpendedMap({
    show,
    setShow,
    player,
    playerName,
    handleProgress,
    isPaused,
    showIsPaused,
    toggleProject,
    openStage,
    StartTurnMessageDisable,
    isStartTurnMessageShowing,
    toggleBeginTurnPopUp,
    BeginTurnPopUpShow,
    setNewTurn,
    ProjectScopeDisable,
    toggleDisableScreen,
    SoundPlay,
    value,
    checkedTask,
    taskToggle,
    ExecuteTaskPopUpShow,
}) {
    const startCameraPosition = 135;
    const positionGlobal = player;
    const counter = positionGlobal / 3;
    const yReset = startCameraPosition - (counter * 75);
    const defaultMapValue = {
        scale: value.scale - 0.25,
        translation: { x: 0, y: value.translation.y + yReset },
    };

    const position = {
        top: 50,
        left: 0,
    };
    const [mapValue, setMapValue] = useState(defaultMapValue);
    const { t } = useTranslation();
    const { colors } = themeStyles;
    const tileTypes = {
        'planned-task': colors.darkGreen,
        'unplanned-task': colors.darkGreen,
        Risk: colors.red,
        'mile-stone': colors.black,
        Constraint: colors.orange,
        gate: colors.darkGray,
        'finish': colors.purple
    };
    const handleRestartMap = () => {
        setMapValue({
            scale: 0.75,
            translation: { x: 0, y: value.translation.y + yReset },
        });
    };
    if (show) {
        return (
            <Container>
                <div style={{
                    width: '95%', display: 'flex', height: '761px',
                    alignItems: 'center', position: 'absolute', justifyContent: ' flex-end',
                }}>
                    <LargeMapContainer>
                        <LargeMapBackground>
                            <div style={{
                                width: '95%',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                cursor: 'pointer',
                                marginTop: '20px',
                                position: 'absolute',
                                zIndex: '5',
                            }}><X onClick={() => setShow(false)} /></div>
                            <TileContainer />
                            <IconContainer>
                                <HelpContainer onClick={() => handleRestartMap()}>
                                    <TargetIcon />
                                </HelpContainer>
                            </IconContainer>
                            <MapInteractionCSS
                                value={mapValue}
                                onChange={value => setMapValue(value)}
                            >
                                {BoardData.map((current, index, array) => {
                                    let reverse = false; // sets the gradient to be reversed
                                    if (current.id === 0) {
                                        return (
                                            <Tile
                                                key={current.id}
                                                number={current.id}
                                                type={current.type}
                                                player={player}
                                                position={player}
                                                playerName={playerName}
                                                top={`${position.top}vh`}
                                                left={`${position.left - 10}vw`}
                                                handleProgress={handleProgress}
                                                isPaused={isPaused}
                                                showIsPaused={showIsPaused}
                                                toggleProject={toggleProject}
                                                openStage={openStage}
                                                StartTurnMessageDisable={
                                                    StartTurnMessageDisable
                                                }
                                                isStartTurnMessageShowing={
                                                    isStartTurnMessageShowing
                                                }
                                                toggleBeginTurnPopUp={toggleBeginTurnPopUp}
                                                BeginTurnPopUpShow={
                                                    BeginTurnPopUpShow
                                                }
                                                setNewTurn={setNewTurn}
                                                SoundPlay={SoundPlay}
                                                ProjectScopeDisable={ProjectScopeDisable}
                                                toggleProjectSound={toggleProjectSound}
                                                toggleDisableScreen={toggleDisableScreen}
                                                checkedTask={checkedTask}
                                                taskToggle={taskToggle}
                                                ExecuteTaskPopUpShow={ExecuteTaskPopUpShow}
                                                isExpendedMap
                                            />
                                        );
                                    }
                                    if (current.id === 1) {
                                        return (
                                            <>
                                                {' '}
                                                <Tile
                                                    key={current.id}
                                                    number={current.id}
                                                    type={current.type}
                                                    player={player}
                                                    position={player}
                                                    playerName={playerName}
                                                    top={`${position.top}vh`}
                                                    left={`${position.left}vw`}
                                                    handleProgress={handleProgress}
                                                    isPaused={isPaused}
                                                    showIsPaused={showIsPaused}
                                                    toggleProject={toggleProject}
                                                    openStage={openStage}
                                                    StartTurnMessageDisable={
                                                        StartTurnMessageDisable
                                                    }
                                                    isStartTurnMessageShowing={
                                                        isStartTurnMessageShowing
                                                    }
                                                    toggleBeginTurnPopUp={toggleBeginTurnPopUp}
                                                    BeginTurnPopUpShow={
                                                        BeginTurnPopUpShow
                                                    }
                                                    setNewTurn={setNewTurn}
                                                    SoundPlay={SoundPlay}
                                                    ProjectScopeDisable={ProjectScopeDisable}
                                                    toggleProjectSound={toggleProjectSound}
                                                    toggleDisableScreen={toggleDisableScreen}
                                                    checkedTask={checkedTask}
                                                    taskToggle={taskToggle}
                                                    ExecuteTaskPopUpShow={ExecuteTaskPopUpShow}
                                                    isExpendedMap
                                                />
                                                <RightLine
                                                    style={{
                                                        top: `${position.top + 4}vh`,
                                                        left: `${position.left - 7}vw`,
                                                    }}
                                                    previousCardColor={
                                                        tileTypes[array[index - 0].type]
                                                    }
                                                    currentCardColor={
                                                        tileTypes[array[index].type]
                                                    }
                                                    reverse={reverse}
                                                />
                                            </>
                                        );
                                    }
                                    if (current.id === BoardData.length) {
                                        return (
                                            <>
                                                <Tile
                                                    key={current.id}
                                                    number={current.id}
                                                    type={current.type}
                                                    player={player}
                                                    position={player}
                                                    playerName={playerName}
                                                    top={`${position.top}vh`}
                                                    left={`${position.left - 10}vw`}
                                                    handleProgress={handleProgress}
                                                    isPaused={isPaused}
                                                    showIsPaused={showIsPaused}
                                                    toggleProject={toggleProject}
                                                    openStage={openStage}
                                                    StartTurnMessageDisable={
                                                        StartTurnMessageDisable
                                                    }
                                                    isStartTurnMessageShowing={
                                                        isStartTurnMessageShowing
                                                    }
                                                    toggleBeginTurnPopUp={toggleBeginTurnPopUp}
                                                    BeginTurnPopUpShow={
                                                        BeginTurnPopUpShow
                                                    }
                                                    setNewTurn={setNewTurn}
                                                    SoundPlay={SoundPlay}
                                                    toggleProjectSound={toggleProjectSound}
                                                    ProjectScopeDisable={ProjectScopeDisable}
                                                    toggleDisableScreen={toggleDisableScreen}
                                                    checkedTask={checkedTask}
                                                    taskToggle={taskToggle}
                                                    ExecuteTaskPopUpShow={ExecuteTaskPopUpShow}
                                                    isExpendedMap
                                                />
                                                <RightLine
                                                    style={{
                                                        top: `${position.top + 4}vh`,
                                                        left: `${position.left - 7}vw`,
                                                    }}
                                                    previousCardColor={
                                                        tileTypes[array[index - 1].type]
                                                    }
                                                    currentCardColor={
                                                        tileTypes[array[index].type]
                                                    }
                                                    reverse={reverse}
                                                />
                                            </>
                                        );
                                    }
                                    switch (current.id % 8) {
                                        default:
                                        case 0:
                                        case 1:
                                        case 4:
                                        case 5:
                                            position.top -= 18;

                                            return (
                                                <>
                                                    <UpLine
                                                        style={{
                                                            top: `${position.top + 7}vh`,
                                                            left: `${position.left + 2}vw`,
                                                        }}
                                                        previousCardColor={
                                                            tileTypes[array[index - 1].type]
                                                        }
                                                        currentCardColor={
                                                            tileTypes[array[index].type]
                                                        }
                                                    />
                                                    <Tile
                                                        key={current.id}
                                                        number={current.id}
                                                        type={current.type}
                                                        player={player}
                                                        position={player}
                                                        playerName={playerName}
                                                        top={`${position.top}vh`}
                                                        left={`${position.left}vw`}
                                                        handleProgress={handleProgress}
                                                        isPaused={isPaused}
                                                        showIsPaused={showIsPaused}
                                                        toggleProject={toggleProject}
                                                        openStage={openStage}
                                                        StartTurnMessageDisable={
                                                            StartTurnMessageDisable
                                                        }
                                                        isStartTurnMessageShowing={
                                                            isStartTurnMessageShowing
                                                        }
                                                        toggleBeginTurnPopUp={toggleBeginTurnPopUp}
                                                        BeginTurnPopUpShow={
                                                            BeginTurnPopUpShow
                                                        }
                                                        setNewTurn={setNewTurn}
                                                        SoundPlay={SoundPlay}
                                                        toggleProjectSound={toggleProjectSound}
                                                        ProjectScopeDisable={ProjectScopeDisable}
                                                    toggleDisableScreen={toggleDisableScreen}
                                                    checkedTask={checkedTask}
                                                    taskToggle={taskToggle}
                                                    ExecuteTaskPopUpShow={ExecuteTaskPopUpShow}
                                                    isExpendedMap
                                                />
                                                </>
                                            );
                                        case 2:
                                        case 3:
                                            position.left += 10;

                                            reverse = true;
                                            return (
                                                <>
                                                    <RightLine
                                                        style={{
                                                            top: `${position.top + 4}vh`,
                                                            left: `${position.left - 7}vw`,
                                                        }}
                                                        previousCardColor={
                                                            tileTypes[array[index - 1].type]
                                                        }
                                                        currentCardColor={
                                                            tileTypes[array[index].type]
                                                        }
                                                        reverse={reverse}
                                                    />
                                                    <Tile
                                                        key={current.id}
                                                        number={current.id}
                                                        type={current.type}
                                                        player={player}
                                                        position={player}
                                                        playerName={playerName}
                                                        top={`${position.top}vh`}
                                                        left={`${position.left}vw`}
                                                        handleProgress={handleProgress}
                                                        isPaused={isPaused}
                                                        showIsPaused={showIsPaused}
                                                        toggleProject={toggleProject}
                                                        openStage={openStage}
                                                        StartTurnMessageDisable={
                                                            StartTurnMessageDisable
                                                        }
                                                        isStartTurnMessageShowing={
                                                            isStartTurnMessageShowing
                                                        }
                                                        toggleBeginTurnPopUp={toggleBeginTurnPopUp}
                                                        BeginTurnPopUpShow={
                                                            BeginTurnPopUpShow
                                                        }
                                                        setNewTurn={setNewTurn}
                                                        SoundPlay={SoundPlay}
                                                        toggleProjectSound={toggleProjectSound}
                                                        ProjectScopeDisable={ProjectScopeDisable}
                                                    toggleDisableScreen={toggleDisableScreen}
                                                    checkedTask={checkedTask}
                                                    taskToggle={taskToggle}
                                                    ExecuteTaskPopUpShow={ExecuteTaskPopUpShow}
                                                    isExpendedMap
                                                />
                                                </>
                                            );
                                        case 6:
                                        case 7:
                                            position.left -= 10;
                                            return (
                                                <>
                                                    <RightLine
                                                        style={{
                                                            top: `${position.top + 4}vh`,
                                                            left: `${position.left + 3}vw`,
                                                        }}
                                                        previousCardColor={
                                                            tileTypes[array[index - 1].type]
                                                        }
                                                        currentCardColor={
                                                            tileTypes[array[index].type]
                                                        }
                                                        reverse={reverse}
                                                    />
                                                    <Tile
                                                        key={current.id}
                                                        number={current.id}
                                                        type={current.type}
                                                        player={player}
                                                        position={player}
                                                        playerName={playerName}
                                                        top={`${position.top}vh`}
                                                        left={`${position.left}vw`}
                                                        handleProgress={handleProgress}
                                                        isPaused={isPaused}
                                                        showIsPaused={showIsPaused}
                                                        toggleProject={toggleProject}
                                                        openStage={openStage}
                                                        StartTurnMessageDisable={
                                                            StartTurnMessageDisable
                                                        }
                                                        isStartTurnMessageShowing={
                                                            isStartTurnMessageShowing
                                                        }
                                                        toggleBeginTurnPopUp={toggleBeginTurnPopUp}
                                                        BeginTurnPopUpShow={
                                                            BeginTurnPopUpShow
                                                        }
                                                        setNewTurn={setNewTurn}
                                                        SoundPlay={SoundPlay}
                                                        toggleProjectSound={toggleProjectSound}
                                                        ProjectScopeDisable={ProjectScopeDisable}
                                                    toggleDisableScreen={toggleDisableScreen}
                                                    checkedTask={checkedTask}
                                                    taskToggle={taskToggle}
                                                    ExecuteTaskPopUpShow={ExecuteTaskPopUpShow}
                                                    isExpendedMap
                                                />
                                                </>
                                            );
                                    }
                                })}
                            </MapInteractionCSS>
                        </LargeMapBackground>
                        <InfoContainer>
                            <LineWrapper>
                                <ImageContainer> <Ellipse47 /> </ImageContainer>
                                <TextContainer>{t(`global_variables.game_element.planned_task`)}</TextContainer>
                            </LineWrapper>
                            <LineWrapper>
                                <ImageContainer> <Ellipse48 /> </ImageContainer>
                                <TextContainer>{t(`global_variables.game_element.unplanned_task`)}</TextContainer>
                            </LineWrapper>
                            <LineWrapper>
                                <ImageContainer> <Polygon4 /> </ImageContainer>
                                <TextContainer>{t(`global_variables.game_element.constraint`)}</TextContainer>
                            </LineWrapper>
                            <LineWrapper>
                                <ImageContainer> <Polygon6 /> </ImageContainer>
                                <TextContainer>{t(`global_variables.game_element.risk`)}</TextContainer>
                            </LineWrapper>
                            {/* <LineWrapper>
                                <ImageContainer> <Rectangle75 /> </ImageContainer>
                                <TextContainer>Delay cards taken</TextContainer>
                            </LineWrapper> */}
                            <LineWrapper>
                                <ImageContainer> <Polygon5 /> </ImageContainer>
                                <TextContainer>{t(`global_variables.game_element.milestone`)}</TextContainer>
                            </LineWrapper>
                            <LineWrapper>
                                <ImageContainer> <Ellipse50 /> </ImageContainer>
                                <TextContainer>{t(`global_variables.game_element.gate`)}</TextContainer>
                            </LineWrapper>
                        </InfoContainer>
                    </LargeMapContainer>
                </div>
            </Container >
        );
    }
    return null;
}
